import {
  RESET_PASSWORD,
  RESET_PASSWORD_SUCCESSFUL,
  RESET_PASSWORD_FAILED,
} from "./actionTypes"

export const reserPassword = user => {
  return {
    type: RESET_PASSWORD,
    payload: { user },
  }
}

export const reserPasswordSuccessful = user => {
  return {
    type: RESET_PASSWORD_SUCCESSFUL,
    payload: user,
  }
}

export const reserPasswordFailed = user => {
  return {
    type: RESET_PASSWORD_FAILED,
    payload: user,
  }
}
